import Pattern from './pattern';
import Step from './step';
const getPatternById = (id) => {
    return patternLibrary.find((pattern) => {
        return pattern.id === id;
    });
};
const patternLibrary = [
    new Pattern('Kermit', [
        new Step([0, 0.5], [0, 0.5], false, true),
        new Step([0.5, 1], [0.5, 0], true, false),
        new Step([1, 1.5], [0, 0.5], false, true),
        new Step([1.5, 2], [0.5, 0], true, false),
        new Step([2, 2.5], [0, 0.5], false, true),
        new Step([2.5, 3], [0.5, 1], true, false),
        new Step([3, 3.5], [1, 0.5], false, true),
        new Step([3.5, 4], [0.5, 0], true, false)
    ]),
    new Pattern('Chirp', [
        new Step([0, 0.5], [0, 0.5], false, true),
        new Step([0.5, 1], [0.5, 0], true, false),
        new Step([1, 1.5], [0, 0.5], false, true),
        new Step([1.5, 2], [0.5, 0], true, false),
        new Step([2, 2.5], [0, 0.5], false, true),
        new Step([2.5, 3], [0.5, 0], true, false),
        new Step([3, 3.5], [0, 0.5], false, true),
        new Step([3.5, 4], [0.5, 0], true, false)
    ]),
    new Pattern('Flare orbit (1 click)', [
        new Step([0, 1], [0, 0.5], false, true),
        new Step([1, 2], [0.5, 1], true, false),
        new Step([2, 3], [1, 0.5], false, true),
        new Step([3, 4], [0.5, 0], true, false),
    ]),
    new Pattern('Flare orbit (2 click)', [
        new Step([0, 0.66], [0, 0.33], false, true),
        new Step([0.66, 1.33], [0.33, 0.66], true, true),
        new Step([1.33, 2], [0.66, 1], true, false),
        new Step([2, 2.66], [1, 0.66], false, true),
        new Step([2.66, 3.33], [0.66, 0.33], true, true),
        new Step([3.33, 4], [0.33, 0], true, false),
    ]),
    new Pattern('Swing Flare', [
        new Step([0, 1], [0, 0.5], true, false),
        new Step([1, 2], [0.5, 0], false, true),
        new Step([2, 3], [0, 0.5], true, true),
        new Step([3, 4], [0.5, 0], true, true)
    ]),
    new Pattern('Autobahn fast', [
        new Step([0, 0.333], [0, 0.333], true, false),
        new Step([0.333, 0.666], [0.333, 0], false, true),
        new Step([0.666, 1], [0, 0.333], true, true),
        new Step([1, 1.333], [0.333, 0.666], true, false),
        new Step([1.333, 1.666], [0.666, 0.333], false, true),
        new Step([1.666, 2], [0.333, 0.666], true, true),
        new Step([2, 2.333], [0.666, 1], true, false),
        new Step([2.333, 2.666], [1, 0.5], false, true),
        new Step([2.666, 3], [0.5, 0], true, true),
    ]),
    new Pattern('Autobahn fast (swing)', [
        new Step([0, 0.5], [0, 0.333], true, false),
        new Step([0.5, 0.75], [0.333, 0], false, true),
        new Step([0.75, 1], [0, 0.333], true, true),
        new Step([1, 1.5], [0.333, 0.666], true, false),
        new Step([1.5, 1.75], [0.666, 0.333], false, true),
        new Step([1.75, 2], [0.333, 0.666], true, true),
        new Step([2, 2.5], [0.666, 1], true, false),
        new Step([2.5, 2.75], [1, 0.5], false, true),
        new Step([2.75, 3], [0.5, 0], true, true),
    ]),
    new Pattern('4x Autobahn fast (swing)', [
        new Step([0, 0.5], [0, 0.333], true, false),
        new Step([0.5, 0.75], [0.333, 0], false, true),
        new Step([0.75, 1], [0, 0.333], true, true),
        new Step([1, 1.5], [0.333, 0.666], true, false),
        new Step([1.5, 1.75], [0.666, 0.333], false, true),
        new Step([1.75, 2], [0.333, 0.666], true, true),
        new Step([2, 2.5], [0.666, 1], true, false),
        new Step([2.5, 2.75], [1, 0.5], false, true),
        new Step([2.75, 3], [0.5, 0], true, true),
        new Step([3, 3.5], [0, 0.333], true, false),
        new Step([3.5, 3.75], [0.333, 0], false, true),
        new Step([3.75, 4], [0, 0.333], true, true),
        new Step([4, 4.5], [0.333, 0.666], true, false),
        new Step([4.5, 4.75], [0.666, 0.333], false, true),
        new Step([4.75, 5], [0.333, 0.666], true, true),
        new Step([5, 5.5], [0.666, 1], true, false),
        new Step([5.5, 5.75], [1, 0.5], false, true),
        new Step([5.75, 6], [0.5, 0], true, true),
        new Step([6, 6.5], [0, 0.333], true, false),
        new Step([6.5, 6.75], [0.333, 0], false, true),
        new Step([6.75, 7], [0, 0.333], true, true),
        new Step([7, 7.5], [0.333, 0.666], true, false),
        new Step([7.5, 7.75], [0.666, 0.333], false, true),
        new Step([7.75, 8], [0.333, 0.666], true, true),
        new Step([8, 8.5], [0.666, 1], true, false),
        new Step([8.5, 8.75], [1, 0.5], false, true),
        new Step([8.75, 9], [0.5, 0], true, true),
        new Step([9, 9.5], [0, 0.333], true, false),
        new Step([9.5, 9.75], [0.333, 0], false, true),
        new Step([9.75, 10], [0, 0.333], true, true),
        new Step([10, 10.5], [0.333, 0.666], true, false),
        new Step([10.5, 10.75], [0.666, 0.333], false, true),
        new Step([10.75, 11], [0.333, 0.666], true, true),
        new Step([11, 11.5], [0.666, 1], true, false),
        new Step([11.5, 11.75], [1, 0.5], false, true),
        new Step([11.75, 12], [0.5, 0], true, true),
    ], 12),
    new Pattern('Autobahn fast - first segment', [
        new Step([0, 0.333], [0, 0.333], true, false),
        new Step([0.333, 0.666], [0.333, 0], false, true),
        new Step([0.666, 1], [0, 0.333], true, true),
    ]),
    new Pattern('Boomerang (closed)', [
        new Step([0, 0.33], [0, 0.5], true, false),
        new Step([0.33, 0.66], [0.5, 0], false, true),
        new Step([0.66, 1], [0, 0.5], true, true),
        new Step([1, 1.33], [0.5, 0], true, false),
        new Step([1.33, 1.66], [0, 0.5], false, true),
        new Step([1.66, 2], [0.5, 0], true, true),
        // new Step([2, 2.33], [0, 0.5], true, false),
        // new Step([2.33, 2.66], [0.5, 0], false, true),
        // new Step([2.66, 3], [0, 0.5], true, true),
        //
        // new Step([3, 3.33], [0.5, 0], true, false),
        // new Step([3.33, 3.66], [0, 0.5], false, true),
        // new Step([3.66, 4], [0.5, 0], true, true),
    ]),
    new Pattern('Boomerang (with swing)', [
        new Step([0, 0.5], [0, 0.5], true, false),
        new Step([0.5, 0.75], [0.5, 0], false, true),
        new Step([0.75, 1], [0, 0.5], true, true),
        new Step([1, 1.5], [0.5, 0], true, false),
        new Step([1.5, 1.75], [0, 0.5], false, true),
        new Step([1.75, 2], [0.5, 0], true, true),
        // new Step([2, 2.5], [0, 0.5], true, false),
        // new Step([2.5, 2.75], [0.5, 0], false, true),
        // new Step([2.75, 3], [0, 0.5], true, true),
        //
        // new Step([3, 3.5], [0.5, 0], true, false),
        // new Step([3.5, 3.75], [0, 0.5], false, true),
        // new Step([3.75, 4], [0.5, 0], true, true),
    ]),
    new Pattern('Boomflare', [
        new Step([0, 0.33], [0, 0.33], true, false),
        new Step([0.33, 0.66], [0.33, 0], false, true),
        new Step([0.66, 1], [0, 0.33], true, true),
        new Step([1, 1.33], [0.33, 0], true, false),
        new Step([1.33, 1.66], [0, 0.33], false, true),
        new Step([1.66, 2], [0.33, 0.66], true, true),
        new Step([2, 2.33], [0.66, 1], true, false),
        new Step([2.33, 2.66], [1, 0.66], false, true),
        new Step([2.66, 3], [0.66, 0.33], true, true),
        new Step([3, 3.33], [0.33, 0], true, false),
        new Step([3.33, 3.66], [0, 0.33], false, true),
        new Step([3.66, 4], [0.33, 0], true, true),
    ]),
    new Pattern('1-2 1-2 1-2-3 3', [
        new Step([0, 0.5], [0, 0.333], true, true),
        new Step([0.5, 1], [0.333, 0.666], true, true),
        new Step([1, 1.5], [0, 0.333], true, true),
        new Step([1.5, 2], [0.333, 0.666], true, true),
        new Step([2, 2.5], [0, 0.333], true, true),
        new Step([2.5, 3], [0.333, 0.666], true, true),
        new Step([3, 3.5], [0.666, 1], true, true),
        new Step([3.5, 4], [0.666, 1], true, true),
    ]),
    new Pattern('1-2-3 3r-2r-1r', [
        new Step([0, 0.5], [0, 0.333], true, true),
        new Step([0.5, 1], [0.333, 0.666], true, true),
        new Step([1, 1.5], [0.666, 1], true, true),
        new Step([1.5, 2], [1, 0.666], true, true),
        new Step([2, 2.5], [0.666, 0.333], true, true),
        new Step([2.5, 3], [0.333, 0], true, true),
    ]),
    new Pattern('crazy pattern (experiment)', [
        new Step([0.5, 0.63], [0.82, 0.23], true, true),
        new Step([1.3, 2.85], [0.45, 0.87], true, true),
        new Step([3.1, 3.2], [0.5, 0.23], true, true),
        new Step([3.4, 3.6], [0.5, 0.23], true, true),
    ]),
];
export default patternLibrary;
export { getPatternById, };
